/**
 * 计算两个时间的年月日差值
 * @param {Date|string|number} date1 - 第一个时间（支持Date对象/日期字符串/时间戳）
 * @param {Date|string|number} date2 - 第二个时间（支持Date对象/日期字符串/时间戳）
 * @returns {Object} { years: 年差, months: 月差, days: 日差 } （差值为非负数，date2 - date1 方向）
 */
function getDateDiff(date1, date2) {
    // 1. 统一转换为Date对象并校验有效性
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
        throw new Error('传入的时间格式无效，请检查日期/时间戳是否合法');
    }

    // 2. 确定开始时间和结束时间（保证结束时间 >= 开始时间，避免负数）
    const start = d1 <= d2 ? d1 : d2;
    const end = d1 <= d2 ? d2 : d1;

    // 3. 初始化年月日差值
    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();
    let days = end.getDate() - start.getDate();

    // 4. 修正日差（若结束日期 < 开始日期，向月份借1）
    if (days < 0) {
        // 创建「结束时间的上一个月」的日期对象，获取该月总天数
        const prevMonth = new Date(end.getFullYear(), end.getMonth(), 0);
        days += prevMonth.getDate();
        months -= 1; // 月份减1
    }

    // 5. 修正月差（若月份差 < 0，向年份借1）
    if (months < 0) {
        years -= 1;
        months += 12; // 一年12个月
    }
    if (years && years>0){
        return years+'年'+months+'月'+days+'日'
    }else {
        if (months && months>0){
            return months+'月'+days+'日'
        }else {
            return days+'日'
        }
    }

}
export default {
    getDateDiff
};